import React, { useState } from "react";
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "../../common/Menu/Menu";
import BlogBanner from "./BlogBanner";
import BlogPost from "./BlogPost";
import ElevatorLoader from "../../Loder/ElevatorLoader";

const Blog = () => {
  const [loading, setLoading] = useState(true);
  return (
    <div>
      {loading && <ElevatorLoader onFinish={() => setLoading(false)} />}
      <Menu header_style_2={true} />
      <BlogBanner />
      <BlogPost />
      <FooterThree />
  </div>
  );
};

export default Blog;
